import { useSelector } from 'react-redux';
import { useFacilityByIdsV2 } from 'ui-model';
import { selectCurrentUser, selectCurrentMasterSettings } from '@lib/selectors';
import { useFilterMessagesContext } from 'contexts';
import { UserBase } from '@lib/resources/types';
import { sortedIndexBy } from 'lodash';

export const useViewModel = () => {
  const currentUser = useSelector(selectCurrentUser);

  const settings = useSelector(selectCurrentMasterSettings);
  const isToUseSendAndReceiverFilters = !!settings?.communication?.filterMessagesBySenderAndReceiver;

  const { selectedFacilitiesAndFacilitiesFromGroups, setSender, sender, isLoadingSender } = useFilterMessagesContext();

  const { data: options = [], isLoading: isLoadingFacility } = useFacilityByIdsV2(
    {
      ids: selectedFacilitiesAndFacilitiesFromGroups,
      _sort: 'name',
      _select: 'name',
    },
    { enabled: isToUseSendAndReceiverFilters },
  );
  const allOptions: { name: string; _id: string }[] = [...options];

  if (currentUser?.roles.includes('admin')) {
    // Putting root account in order on the most efficient way
    allOptions.splice(
      sortedIndexBy(allOptions, currentUser as UserBase & { _id: string }, 'name'),
      0,
      currentUser as UserBase & { _id: string },
    );
  }

  const isLoading = isLoadingFacility || isLoadingSender;

  const hideSenderSelector = !isToUseSendAndReceiverFilters || (isLoading && !sender);

  return { isLoading, sender, options: allOptions, setSender, hideSenderSelector };
};
